import type { ReactNode } from 'react';
import { cn } from '@design-system';
import { CalendarClock, Check } from 'lucide-react';

interface QuoteFeaturesAndBenefitsProps {
  children: ReactNode;
  className?: string;
}

export function QuoteFeaturesAndBenefits({ children, className }: QuoteFeaturesAndBenefitsProps) {
  return (
    <section
      className={cn('flex flex-wrap items-center gap-x-5 gap-y-2', className)}
      data-testid="quote-features-and-benefits"
      aria-label="Features and benefits"
    >
      {children}
    </section>
  );
}

interface BenefitPeriodBadgeProps {
  label: string;
}

export function BenefitPeriodBadge({ label }: BenefitPeriodBadgeProps) {
  return (
    <span
      className="text-foreground inline-flex w-fit items-center gap-1.5 text-sm font-medium"
      data-testid="benefit-period-badge"
    >
      <CalendarClock className="text-muted-foreground size-4 shrink-0" />
      {label}
    </span>
  );
}

interface CouplesDiscountBadgeProps {
  appearance?: 'badge' | 'inline';
}

export function CouplesDiscountBadge({ appearance = 'badge' }: CouplesDiscountBadgeProps) {
  const isInline = appearance === 'inline';

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center font-medium',
        isInline
          ? 'text-foreground gap-1.5 text-sm'
          : 'min-h-7 justify-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs text-emerald-700',
      )}
      data-testid="couples-discount-badge"
    >
      {isInline && <Check className="size-4 shrink-0 text-green-600" />}
      Couples Discount
    </span>
  );
}
